module.exports = __webpack_public_path__ + "img/generated-1772425760953.2ea6db5e.png";